<template>
  <div class="columns is-multiline nospace">
    <div class="column">
      <h3 class="h3 is-size-5 margin-bottom-10">
        Available
      </h3>
      <button
        class="button is-inline is-fullwidth is-success is-small"
        :disabled="addDisabled"
        @click="add"
      >
        Add
        <div class="icon mgl-5">
          <i class="mdi mdi-arrow-right"></i>
        </div>
      </button>
      <div class="select is-multiple is-inline is-fullwidth">
        <select
          ref="a"
          multiple
          size="15"
          :disabled="disabled"
          @input="checkSelected('a')"
        >
          <option
            v-for="computer of allUnselected"
            :key="computer.uid"
            :value="computer.uid"
            >{{ name(computer) }}</option
          >
        </select>
      </div>
    </div>

    <div class="column">
      <h3 class="h3 is-size-5 margin-bottom-10">
        Selected
      </h3>
      <button
        class="button is-inline is-fullwidth is-danger is-small"
        :disabled="removeDisabled"
        @click="remove"
      >
        <div class="icon mgr-5">
          <i class="mdi mdi-arrow-left"></i>
        </div>
        Remove
      </button>
      <div class="select is-multiple is-inline is-fullwidth">
        <select
          ref="b"
          multiple
          size="15"
          :disabled="disabled"
          @input="checkSelected('b')"
        >
          <option
            v-for="computer of allSelected"
            :key="computer.uid"
            :value="computer.uid"
            >{{ name(computer) }}</option
          >
        </select>
      </div>
    </div>
  </div>
</template>

<style scoped>
select[multiple] option {
  padding: 0.1em 1em;
  overflow-x: auto;
  font-size: 14px;
}

select,
.select {
  border-radius: 0px !important;
}
.select select:active,
.select select:focus,
.select select:hover {
  border-color: #dbdbdb !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

button {
  border-radius: 0px;
}

.nospace {
  padding: 0px;
  /* margin: 0px; */
}

.mgl-5 {
  margin-left: 5px !important;
}

.mgr-5 {
  margin-right: 5px !important;
}
</style>

<script>
import computerHelper from "@/utils/computer";

export default {
  props: {
    computers: Array,
    selectedUIDs: Array,
    domain: Object,
    disabled: Boolean,
  },
  components: {
    CheckboxText: () => import("@/components/singles/CheckboxText.vue"),
  },
  data() {
    return { maxNameLength: 23, addDisabled: true, removeDisabled: true };
  },
  computed: {
    allSelected() {
      return this.computers.filter(
        (x) => this.selectedUIDs.indexOf(x.uid) !== -1
      );
    },
    allUnselected() {
      return this.computers.filter(
        (x) => this.selectedUIDs.indexOf(x.uid) === -1
      );
    },
    selected() {
      return (computer) => {
        return this.selectedUIDs.some((x) => x === computer.uid);
      };
    },
    name() {
      return (computer) => {
        const name = computerHelper.getName(computer);
        if (name.length > this.maxNameLength)
          return name.slice(0, this.maxNameLength) + " ...";
        else return name;
      };
    },
  },
  created() {},
  methods: {
    checkSelected(ref) {
      const isEmpty = this.$refs[ref].selectedOptions.length === 0;

      if (ref == "a") this.addDisabled = isEmpty;
      else this.removeDisabled = isEmpty;
    },
    add() {
      this.addDisabled = true;
      const selected = [...this.$refs.a.selectedOptions].map((x) => x.value);

      this.$emit("change", [
        ...this.selectedUIDs,
        ...selected.filter((x) => this.selectedUIDs.indexOf(x) === -1),
      ]);
    },
    remove() {
      this.removeDisabled = true;
      const selected = [...this.$refs.b.selectedOptions].map((x) => x.value);

      this.$emit(
        "change",
        this.selectedUIDs.filter((x) => selected.indexOf(x) === -1)
      );
    },
  },
};
</script>
